$(function(){
	$('.header-page').each(function(){
		if($(this).find('h1').text().includes('Payment Portal')){
			$(this).attr('id','paymentsLanding');
		}
	});
});